import { ResumeDto } from '@eva/types/dto';

export const isResume = (obj: Partial<ResumeDto | unknown>): obj is ResumeDto => !!(obj as ResumeDto)?.resumeId;
